__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "liveto-mfe-pos";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@fluent/react", "0.15.2", () => (Promise.all([__webpack_require__.e(265), __webpack_require__.e(725)]).then(() => (() => (__webpack_require__(4725))))));
			register("@mantine/core", "7.8.0", () => (Promise.all([__webpack_require__.e(228), __webpack_require__.e(265), __webpack_require__.e(21)]).then(() => (() => (__webpack_require__(4228))))));
			register("@mantine/modals", "7.8.0", () => (Promise.all([__webpack_require__.e(265), __webpack_require__.e(284), __webpack_require__.e(243)]).then(() => (() => (__webpack_require__(4243))))));
			register("@mantine/notifications", "7.8.0", () => (Promise.all([__webpack_require__.e(170), __webpack_require__.e(265), __webpack_require__.e(21), __webpack_require__.e(284)]).then(() => (() => (__webpack_require__(5170))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(278), __webpack_require__.e(265)]).then(() => (() => (__webpack_require__(5278))))));
			register("react-router-dom", "6.21.1", () => (Promise.all([__webpack_require__.e(487), __webpack_require__.e(146), __webpack_require__.e(265), __webpack_require__.e(21)]).then(() => (() => (__webpack_require__(1146))))));
			register("react", "18.2.0", () => (__webpack_require__.e(999).then(() => (() => (__webpack_require__(5999))))));
			initExternal(1032);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};